// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__S9uAf","select":"style_select__USrpH"};